module.exports = __webpack_public_path__ + "static/img/winter_jianjiePic.e638cf14.png";